export const menuItems = [
    {
        id: 1,
        icon: 'bx-map-alt',
        label: 'menu.evMap',
        link: '/station',
        authRequired: false,
        roles: []
    },
    /*{
        id: 2,
        icon: 'bx-gas-pump',
        label: 'menu.stationMap',
        link: '/region',
        authRequired: true,
        roles: []
    },*/
    {
        id: 3,
        icon: 'bxs-dashboard',
        label: 'menu.dashboard',
        link: '/main',
        authRequired: true,
        roles: ['USER', 'ADMIN']
    },
    {
        id: 4,
        icon: 'bx-spreadsheet',
        label: 'menu.stationUsageStatus',
        link: '/station-status',
        authRequired: true,
        roles: ['USER', 'ADMIN']
    },
    {
        id: 5,
        icon: 'bx-line-chart',
        label: 'menu.statisticsReport',
        link: '/statistics-report',
        authRequired: true,
        roles: ['USER', 'ADMIN']
    },
    {
        id: 6,
        icon: 'bx bx-car',
        label: 'menu.driverRecommendations',
        link: '/driver-recommend',
        authRequired: true,
        roles: ['USER', 'ADMIN']
    },
    {
        id: 7,
        icon: 'bx-building-house',
        label: 'menu.aptEnergyStatus',
        link: '/demand-manage',
        authRequired: true,
        roles: ['USER', 'ADMIN']
    },

    {
        id: 8,
        icon: 'bx-cog',
        label: 'menu.serviceManagement',
        link: '/manage',
        authRequired: true,
        roles: ['USER', 'ADMIN']
    },
    {
        id: 9,
        label: 'menu.ocpp',
        isTitle: true,
        authRequired: true,
        roles: ['OCPP'],
    },
    {
        id: 90,
        icon: 'bx-bolt-circle',
        label: 'menu.ocpp16',
        authRequired: true,
        roles: ['OCPP'],
        subItems: [
            {
                id: 91,
                label: 'menu.configuration',
                link: '/ocpp/configuration'
            },
            {
                id: 92,
                label: 'menu.operations',
                link: '/ocpp/operations'
            },
            {
                id: 93,
                label: 'menu.monitoring',
                link: '/ocpp/monitoring'
            }
        ]
    },
    {
        id: 95,
        icon: 'bx-bolt-circle',
        label: 'menu.ocpp20',
        link: '/blank',
        authRequired: true,
        roles: ['OCPP']
    },
];
